import { Resend } from './Resend';

export default Resend;
